import { useEffect, useState } from 'react';
import { PreviousClaimSummary } from '../../domain/entities/PreviousClaimSummary';
import { PreviousClaimSummariesNomaRepository } from '../../infraestructure/repositories/PreviousClaimSummariesNomaRepository';

export const usePreviousClaimSummaries = (policyIdentifier: string | undefined) => {
    const [previousClaimSummaries, setPreviousClaimSummaries] = useState<PreviousClaimSummary[]>([]);

    useEffect(() => {
        if (!policyIdentifier) return;
        PreviousClaimSummariesNomaRepository.findByPolicyIdentifier(policyIdentifier)
            .then(setPreviousClaimSummaries)
            .catch(() => setPreviousClaimSummaries([]));
    }, [policyIdentifier]);

    return { previousClaimSummaries };
};
